export default {
    challengeFilters: [],
    prizeFilters: [],
    imageFilters: []
}


// WEBPACK FOOTER //
// ./public/filters/initialState.js